import { Link } from "react-router";
import logoFooterSIA from "@assets/events-awards/sia/logo-footer-sia.png";
import FooterMenuLinks from "@events-awards/components/EventsAwardsFooterComponents/FooterMenuLinks";
import { EVENTS_AWARDS_SIA_PATH } from "@events-awards/utils/constants";
import { SIA_FOOTER_MENU } from "@sia/utils/constants";

/**
 * Component to display footer for desktop view in SIA pages
 */
const SIAFooterDesktop = (): React.ReactElement => {
  return (
    <div
      className="grid w-full grid-cols-6 text-center"
      data-testid="sia-footer-desktop-component"
    >
      <div className="col-span-1 pl-0 pr-3">
        <Link to={EVENTS_AWARDS_SIA_PATH} reloadDocument>
          <img
            src={logoFooterSIA}
            alt="SIA Awards logo"
            width={181}
            height={84}
            className="mb-6"
          />
        </Link>
      </div>

      <div className="col-span-3">
        <h3 className="mb-4 text-left font-poppins text-base font-semibold">
          About Us
        </h3>

        <div className="text-left leading-150 text-white">
          <p>
            The Sustainability Impact Awards (SI Awards), launched on 1 February
            2023, is jointly presented by The Business Times and UOB, with the
            Centre for Governance and Sustainability (CGS) at the National
            University of Singapore Business School as the knowledge partner.
          </p>
        </div>
      </div>

      <div className="col-span-2 ml-4 flex flex-row px-3">
        <div>
          <p className="mb-4 text-left font-semibold">Sections</p>

          <div className="my-2 flex flex-row">
            <FooterMenuLinks
              items={SIA_FOOTER_MENU.slice(0, 3)}
              className="space-y-2"
            />

            <FooterMenuLinks
              items={SIA_FOOTER_MENU.slice(3, 5)}
              className="space-y-2 pl-4"
            />
          </div>
        </div>
        <div className="ml-10 pr-3">
          <p className="mb-4 text-left font-semibold">Quick Links</p>

          <FooterMenuLinks
            items={SIA_FOOTER_MENU.slice(5, 8)}
            className="space-y-2"
          />
        </div>
      </div>
    </div>
  );
};

export default SIAFooterDesktop;
